import { RawEmojiData, AllEmojis } from "@/assets/interfaces";
import { ValidCodepoints, ValidCategories } from "@/assets/types";

// Commented-out emojis were added post 2018 and will not
// properly render on outdated but fairly new devices
const emojis: RawEmojiData = {
  hearts: {
    "0x1F5A4": "Black heart",
    "0x1F9E1": "Orange heart",
    "0x1F48C": "Heart envelope",
    "0x1F49A": "Green heart",
    "0x1F49B": "Yellow heart",
    "0x1F49C": "Purple heart",
    "0x1F49D": "Heart with ribbon",
    "0x1F49E": "Revolving hearts",
    "0x1F493": "Beating heart",
    "0x1F495": "Two hearts",
    "0x1F496": "Sparkling heart",
    "0x1F497": "Growing heart",
    "0x1F498": "Heart with arrow",
    "0x1F499": "Blue heart",
    "0x2763": "Heart exclamation",
    "0x2764": "Red heart"
    // [0x1F90E, "Brown heart"],
    // [0x1F90D, "White heart"],
  },
  flowers: {
    "0x1F3F5": "Rosette",
    "0x1F4AE": "White flower",
    "0x1F33A": "Hibiscus",
    "0x1F33B": "Sunflower",
    "0x1F33C": "Blossom",
    "0x1F337": "Tulip",
    "0x1F338": "Cherry blossom",
    "0x1F339": "Rose",
    "0x1F490": "Bouquet"
  },
  animals: {
    "0x1F40A": "Crocodile",
    "0x1F40B": "Whale",
    "0x1F40C": "Snail",
    "0x1F40D": "Snake",
    "0x1F40E": "Horse",
    "0x1F40F": "Ram",
    "0x1F41A": "Sea shell",
    "0x1F41B": "Caterpillar",
    "0x1F41C": "Ant",
    "0x1F41D": "Honeybee",
    "0x1F41E": "Ladybug",
    "0x1F41F": "Fish",
    "0x1F42A": "Dromedarian camel",
    "0x1F42B": "Bactrian camel",
    "0x1F42C": "Dolphin",
    "0x1F43A": "Wolf",
    "0x1F43B": "Bear",
    "0x1F43C": "Panda",
    "0x1F43F": "Chipmunk",
    "0x1F54A": "Dove",
    "0x1F98A": "Fox",
    "0x1F98B": "Butterfly",
    "0x1F98C": "Deer",
    "0x1F98D": "Gorilla",
    "0x1F98E": "Gecko",
    "0x1F98F": "Rhinoceros",
    "0x1F400": "Rat",
    "0x1F401": "Mouse",
    "0x1F402": "Ox",
    "0x1F403": "Water buffalo",
    "0x1F404": "Cow",
    "0x1F405": "Tiger",
    "0x1F406": "Leopard",
    "0x1F407": "Rabbit",
    "0x1F408": "Cat",
    "0x1F410": "Goat",
    "0x1F411": "Sheep",
    "0x1F412": "Monkey",
    "0x1F413": "Rooster",
    "0x1F414": "Chicken",
    "0x1F415": "Dog",
    "0x1F416": "Pig",
    "0x1F417": "Boar",
    "0x1F418": "Elephant",
    "0x1F419": "Octopus",
    "0x1F420": "Tropical fish",
    "0x1F421": "Blowfish",
    "0x1F422": "Turtle",
    "0x1F423": "Hatching chick",
    "0x1F424": "Baby chick",
    "0x1F426": "Bird",
    "0x1F427": "Penguim",
    "0x1F428": "Koala",
    "0x1F429": "Poodle",
    "0x1F433": "Spouting whale",
    "0x1F438": "Frog",
    "0x1F439": "Hamster",
    "0x1F577": "Spider",
    "0x1F578": "Spider web",
    "0x1F980": "Crab",
    "0x1F981": "Lion",
    "0x1F982": "Scorpion",
    "0x1F983": "Turkey",
    "0x1F984": "Unicorn",
    "0x1F985": "Eagle",
    "0x1F986": "Duck",
    "0x1F987": "Bat",
    "0x1F988": "Shark",
    "0x1F989": "Owl",
    "0x1F990": "Shrimp",
    "0x1F991": "Squid",
    "0x1F992": "Giraffe",
    "0x1F993": "Zebra",
    "0x1F994": "Hedgehog",
    "0x1F997": "Cricket"
    // ["0x1F9AE", "Guide dog"],
    // ["0x1F415", "Service dog"],
    // ["0x1F99D", "Raccoon"],
    // ["0x1F9A5", "Sloth"],
    // ["0x1F9A7", "Orangutan"],
    // ["0x1F999", "Lhama"],
    // ["0x1F99B", "Hippopotamus"],
    // ["0x1F9A6", "Otter"],
    // ["0x1F9A8", "Skunk"],
    // ["0x1F998", "Kangaroo"],
    // ["0x1F9A1", "Badger"],
    // ["0x1F9A2", "Swan"],
    // ["0x1F9A9", "Flamingo"],
    // ["0x1F99A", "Peacock"],
    // ["0x1F99C", "Parrot"],
    // ["0x1F99E", "Lobster"],
    // ["0x1F99F", "Mosquito"],
  },
  fruits: {
    "0x1F34A": "Orange",
    "0x1F34B": "Lemon",
    "0x1F34C": "Banana",
    "0x1F34D": "Pineapple",
    "0x1F34E": "Red apple",
    "0x1F34F": "Green apple",
    "0x1F95D": "Kiwi",
    "0x1F345": "Tomato",
    "0x1F347": "Grapes",
    "0x1F348": "Melon",
    "0x1F349": "Watermelon",
    "0x1F350": "Pear",
    "0x1F351": "Peach",
    "0x1F352": "Cherries",
    "0x1F353": "Strawberry",
    "0x1F951": "Avocado",
    "0x1F965": "Coconut"
    // ["0x1F96D", "Mango"],
  },
  food: {
    "0x1F9C0": "Cheese",
    "0x1F32D": "Hot dog",
    "0x1F32E": "Taco",
    "0x1F32F": "Burrito",
    "0x1F35A": "Cooked rice",
    "0x1F35B": "Curry",
    "0x1F35C": "Noodles",
    "0x1F35D": "Spaghetti",
    "0x1F35E": "Bread",
    "0x1F35F": "French fries",
    "0x1F36A": "Cookie",
    "0x1F36B": "Chocolate bar",
    "0x1F36E": "Custard",
    "0x1F36F": "Honey pot",
    "0x1F37D": "Fork and knife with plate",
    "0x1F37F": "Popcorn",
    "0x1F95B": "Milk glass",
    "0x1F95E": "Pancakes",
    "0x1F95F": "Dumpling",
    "0x1F96A": "Sandwich",
    "0x1F96B": "Canned food",
    "0x1F354": "Hamburger",
    "0x1F355": "Pizza",
    "0x1F358": "Rice cracker",
    "0x1F359": "Onigiri",
    "0x1F360": "Roasted sweet potato",
    "0x1F361": "Dango",
    "0x1F362": "Oden",
    "0x1F363": "Sushi",
    "0x1F364": "Fried shrimp",
    "0x1F365": "Fishcake",
    "0x1F366": "Soft ice cream",
    "0x1F367": "Shaved ice",
    "0x1F368": "Ice cream",
    "0x1F369": "Donut",
    "0x1F370": "Shortcake",
    "0x1F371": "Bento box",
    "0x1F372": "Soup",
    "0x1F374": "Fork and knife",
    "0x1F375": "Tea",
    "0x1F382": "Birthday cake",
    "0x1F944": "Spoon",
    "0x1F950": "Croissant",
    "0x1F953": "Bacon",
    "0x1F956": "Baguette",
    "0x1F957": "Green salad",
    "0x1F958": "Paella",
    "0x1F959": "Doner kebab",
    "0x1F960": "Fortune cookie",
    "0x1F961": "Takeout box",
    "0x1F962": "Chopsticks",
    "0x1F967": "Pie",
    "0x1F968": "Pretzel",
    "0x2615": "Coffee"
    // ["0x1F96F", "Bagel"],
    // ["0x1F9C7", "Waffle"],
    // ["0x1F9C2", "Salt"],
    // ["0x1F96E", "Mooncake"],
    // ["0x1F9C1", "Cupcake"],
  },
  astra: {
    "0x1F4E1": "Satellite antenna",
    "0x1F6F0": "Satellite",
    "0x1F6F8": "Flying sauce",
    "0x1F30C": "Milky way",
    "0x1F30D": "Globe showing Europe-Africa",
    "0x1F30E": "Globe showing Americas",
    "0x1F30F": "Globe showing Asia-Australia",
    "0x1F31A": "Smiley new moon",
    "0x1F31B": "Smiley first quarter moon",
    "0x1F31C": "Smiley last quarter moon",
    "0x1F31D": "Smiley full moon",
    "0x1F31E": "Smiley sun",
    "0x1F31F": "Glowing star",
    "0x1F52D": "Telescope",
    "0x1F303": "Starry night",
    "0x1F310": "Globe with meridians",
    "0x1F311": "New moon",
    "0x1F312": "Waxing crescent moon",
    "0x1F313": "First quarter moon",
    "0x1F314": "Waxing gibbous moon",
    "0x1F315": "Full moon",
    "0x1F316": "Waning gibbous moon",
    "0x1F317": "Last quarter moon",
    "0x1F318": "Waning crescent moon",
    "0x1F319": "Crescent moon",
    "0x1F320": "Shooting star",
    "0x1F680": "Rocket",
    "0x2B50": "Star",
    "0x2600": "Sun",
    "0x2604": "Comet"
  }
};

// Return array of codepoints for a given category
export const getCategory = (category: ValidCategories) => {
  const codepoints: ValidCodepoints[] = Object.keys(emojis[category]);
  return codepoints;
};

export const categoryNames = () => {
  const categories: ValidCategories[] = Object.keys(emojis);
  return categories;
};

// Retrieve all emojis In store-ready structure
export const retrieveAll = () => {
  const allEmojis: AllEmojis = {};

  // Get existing categories
  const categories: ValidCodepoints[] = categoryNames();

  for (const category of categories) {
    // Retrieve emoji codepoints for each category
    const codepoints = getCategory(category);

    // Add each emoji to the allEmojis object
    for (const codepoint of codepoints) {
      const label: string = emojis[category][codepoint];
      allEmojis[codepoint] = {
        label: label,
        category: category
      };
    }
  }
  return allEmojis;
};
